import { UserContext } from "@/context/User/UserContext";
import { getSingleInsurer } from "@/services/Insurer.service";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { useParams } from "react-router-dom";
import EditInsurer from "../dialog/EditInsurer";

const Insurer = () => {
	const { id } = useParams<{ id: string }>() as { id: string };
	const user = useContext(UserContext);

	const insurer = useQuery({
		queryKey: ["insurer", id],
		queryFn: () => getSingleInsurer(parseInt(id), user?.accessToken!),
		enabled: !!user?.accessToken,
		staleTime: 3000,
	});

	return (
		<>
			{insurer.isLoading ? (
				<div className="grid gap-4 pt-4">
					{Array.from({ length: 2 }).map((_, num) => (
						<div key={num} className="h-12 w-full bg-gray-200 animate-pulse" />
					))}
				</div>
			) : insurer.data ? (
				<>
					<div className="flex gap-3 items-end justify-between">
						<h1 className="font-medium text-4xl">
							Insurer: {insurer.data.insurername}
						</h1>
						<EditInsurer user={user} insurer={insurer.data} />
					</div>
					<div className="border-y my-3 py-4 border-zinc-200">
						<div className="grid grid-cols-1 sm:grid-cols-2">
							<div className="flex gap-4">
								<div className="flex flex-col gap-2 text-zinc-500 font-light text-nowrap">
									<p>ID</p>
									<p>Designation</p>
								</div>
								<div className="flex flex-col gap-2">
									<p>{insurer.data.insurerid}</p>
									<p>{insurer.data.insurername}</p>
								</div>
							</div>
						</div>
					</div>
				</>
			) : null}
		</>
	);
};

export default Insurer;
